import { createSlice } from '@reduxjs/toolkit';
import { ICompanyDetail } from '../../../auth/interfaces/ICompanyDetail';
import { CompanyDetailReducer } from '../../reducers/CompanyDetailReducer';
import { IpafStatus } from '../../../dashboard/enums/IpafStatus';

const initialState: ICompanyDetail = {
	company_id: 0,
	company_name: '',
	company_phone: '',
	cnpj: '',
	email: '',
	customer_name: '',
	website: '',
	phone: '',
	kam_hubspot_id: '',
	assessment_created_at: null,
	assessment_status: 'NO_ASSESSMENT',
	assessment_id: null,
	forms_info: {
		forms_completed: 0,
		total_forms: 0,
		ipaf_status: IpafStatus.INITIAL,
		ipaf_id: null,
		last_ipaf: null,
		expiration_date: '',
		products: [],
		is_expiring_soon: false,
	},
	products: [],
};

export const companyDetailSlice = createSlice({
	name: 'companyDetail',
	initialState,
	reducers: CompanyDetailReducer,
});

export const { setCompanyDetail, updateProducts, updateFormsInfo } =
	companyDetailSlice.actions;

export default companyDetailSlice.reducer;
